import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PrintProductsGroup from '../../index';

const propTypes = {
  className: PropTypes.string,
  printCategory: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    print_products: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
  renderPrintProductGroup: PropTypes.func,
  photo: PropTypes.shape({
    id: PropTypes.string,
  }),
  readOnly: PropTypes.bool,
  onCheckout: PropTypes.func,
  onCartItemToggle: PropTypes.func.isRequired,
  getCartItem: PropTypes.func,
};

const PrintCategoryPrintProducts = ({
  className,
  printCategory,
  renderPrintProductGroup,
  onCartItemToggle,
  onCheckout,
  readOnly,
  photo,
  getCartItem,
}) => {
  const classes = classNames({
    [className]: !!className,
  });
  const printProducts = printCategory.print_products.records ?? [];

  return (
    <div className={classes}>
      <PrintProductsGroup
        printProducts={printProducts ?? []}
        onCartItemToggle={onCartItemToggle}
        onCheckout={onCheckout}
        readOnly={readOnly}
        photo={photo}
        renderPrintProduct={renderPrintProductGroup}
        getCartItem={getCartItem}
      />
    </div>
  );
};

PrintCategoryPrintProducts.propTypes = propTypes;

export default PrintCategoryPrintProducts;
